import Config from './config.json';
var API_URL = Config.baseURL;
var REQUEST_TIME_OUT = 30000;
export default {
    API_URL: API_URL,
    REQUEST_TIME_OUT: REQUEST_TIME_OUT
};
